import { useEntityUrl } from 'framework/routing';
import { SERVICE_CATALOG_PATH } from '../useServiceCatalogService';

export const useServiceCatalogUrl = () => {
  const urls = useEntityUrl({
    baseLink: SERVICE_CATALOG_PATH,
  });

  return {
    ...urls,
    getCostsStructuresUrl: (id: string) => `${urls.getSingleEntityUrl(id)}/costs/structures`,
    getKPIStructuresUrl: (id: string) => `${urls.getSingleEntityUrl(id)}/kpi/structures`,
    getKPIValuesUrl: (id: string) => `${urls.getSingleEntityUrl(id)}/kpi/values`,
  };
};
